import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ApprovalsService} from '../approvals.service';
import {ConfigService} from '../../../../core/services/config.service';

@Component({
    selector: 'itpx-order-details-modal',
    templateUrl: './order-details.component.html',
    styleUrls: ['order-details.component.css']
})
export class OrderDetailsComponent implements OnInit, OnDestroy {

    @Input() data: any = null;

    public approvalDetails: any = null;
    public source: string = null;

    constructor(private approvalsService:ApprovalsService, private configService: ConfigService) {}

    ngOnInit(): void {
        this.approvalDetails = this.data.pendingApproval;
        this.source = this.data.source ? this.data.source : 'default'
    }

    navigateToProduct(productVariant) {
        const SKU = this.source === 'default' ? productVariant.sku : productVariant.lxpProductSku ; 
        window.open(this.configService.get('server').productMarketplace + '/products?filter=' + SKU, "_blank", 'noopener,noreferrer');
    }

    ngOnDestroy(): void {

    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/approvals/order-details/order-details.component.ts